module.exports = __webpack_public_path__ + "img/logo-sm-dark.34b064d1.png";